import { render, staticRenderFns } from "./ScoreboardListStudy.vue?vue&type=template&id=024eb790&"
import script from "./ScoreboardListStudy.vue?vue&type=script&lang=ts&"
export * from "./ScoreboardListStudy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports